import React, { useEffect, useState } from "react";
import Fileupload from "../../components/Fileupload";
import { useParams } from "react-router-dom";
import { getStage, send_pageid_creation } from "../../api/api";
import { toast } from "react-toastify";

const PageIdCreation = ({ fileId, renderpage }) => {
  const [file, setFile] = useState([]);
  const [fileName, setFileName] = useState("");
  const [romanCount, setRomanCount] = useState("");
  const [stage, setStage] = useState();

  const { category } = useParams();

  useEffect(() => {
    getstage();
  }, []);

  const getstage = async () => {
    let data = await getStage(fileId, category);
    if (data.data) {
      setStage({
        previous: data.data.previous_process,
        next: data.data.next_process,
      });
    }
  };
  const handleSetCount=(e)=>{
    const{value}=e.target
    if (/^\d*\.?\d*$/.test(value)) {
     setRomanCount(value)
  }
}

  const senddata = async (event) => {
    const button = event.currentTarget;
    button.disabled = true; // Disable the button
    document.body.style.cursor = "wait";

    try {
      if (file.length > 0 && romanCount && romanCount?.trim() !== "") {
        event.currentTarget.disabled = true;
        document.body.style.cursor = "wait";
        let response = await send_pageid_creation(
          fileId,
          file,
          category,
          Number(romanCount),
          fileName
        );
        if (response.data) {
          document.body.style.cursor = "default";
          handleNext(fileId, stage.next);
        } else {
          // alert(response.error.message);
          toast.error(response.error.message);
          button.disabled = false; // Disable the button
          document.body.style.cursor = "default";
        }
      } else {
        // alert("Please upload a file to continue.");
        if(!file ||!file.length){
          
        toast.warn("Please upload a file to continue");
        }
        else{
          toast.warn("Please Enter RomanPageCount to continue");
        }
        button.disabled = false; // Disable the button
        document.body.style.cursor = "default";
      }
    } catch (e) {
      // console.log(e);
      toast.error(e);
      button.disabled = false; // Disable the button
      document.body.style.cursor = "default";
    }
  };

  const skipstage = async (event) => {

    try {
      event.currentTarget.disabled = true;
      document.body.style.cursor = "wait";
      let response = await send_pageid_creation(
        fileId,
        file,
        category,
        0,
        fileName
      );
      if (response.data) {
        document.body.style.cursor = "default";
        handleNext(fileId, stage.next);
      } else {
        // alert(response.error.message);
        toast.error(response.error.message);
      }
    } catch (e) {
      // console.log(e);
      toast.error(e);
    }
  };

  const handleNext = (fileId, nextpage) => {
    renderpage(fileId, nextpage);
  };
  return (
    <div className="flex w-full">
      <div className="p-8 flex flex-col gap-8 h-[100%] min-h-[70vh] w-full">
        <div className="flex w-full justify-between text-left items-center">
          <h1 className="text-24 font-semibold">Page ID Creation</h1>
          {/* <button className="flex gap-2 px-3 py-3 border-[1.5px] border-highlighttext rounded-[12px]">
            <img
              src={process.env.PUBLIC_URL + "/images/gotoeditor.svg"}
              alt="editor_logo"
            ></img>
            <p className="text-highlighttext text-14 font-semibold">
              Download Template
            </p>
          </button> */}
        </div>
        <div className="w-full shadow-commonshadow rounded-[24px]">
          <Fileupload
            setFiles={setFile}
            setFileName={setFileName}
            category={category}
          />
        </div>
        <div className="flex flex-col lg:w-1/3 gap-5 text-left">
          <p className="text-black font-semibold text-20">Roman Page Count<span className="text-red">*</span></p>
          <div className="flex flex-col gap-5">
            <div

              className="border-[1px] border-commonborder rounded-[12px] px-3 py-3"
            >
              <input className="w-full outline-none bg-transparent" type="text" placeholder="Enter roman number count" name='RomanPageCount' value={romanCount} onChange={(e) => handleSetCount(e)} />

            </div>
            {/* {!romanCount? <p className="text-red"> {"*"}Roman Page Count is Required</p> : <></>}  */}
          </div>
        </div>
        <div className="flex mt-20 gap-5 ml-auto">
          <button
            onClick={(event) => {
              handleNext(fileId, stage.previous);
            }}
            className="w-fit flex "
          >
            <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
              PREV
            </p>
          </button>
          <button
            onClick={(event) => {
              skipstage(event);
            }}
            className="w-fit flex justify-end"
          >
            <p className="py-3 px-6 rounded-[12px] text-highlight border-[1px] border-highlightblue bg-white text-14 font-bold">
              SKIP
            </p>
          </button>
          <button
            onClick={(event) => {
              senddata(event);
            }}
            className="w-fit flex justify-end"
          >
            <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
              NEXT
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageIdCreation;
